import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import appStore from './utils/redux-store/appStore';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
console.warn = () => { }; // Suppress warnings (development only)

const rootElement = document.getElementById('root');

if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <Provider store={appStore}>
      <Router basename="/ui">
            <App />
          </Router>
      </Provider>
    </React.StrictMode>
  );
} else {
  console.error('Root element not found');
}
